module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer055"
    }
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "calibre_toc_5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ebook_split_006#_idTextAnchor001"
    }
  }, [_vm._v("A Note from the Author"), _c('span', {
    attrs: {
      "id": "_idTextAnchor043"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idgenobjectattribute1",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/_3_-_Note_From_the_Author_Melisa_Caprio.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "photo-caption",
    attrs: {
      "id": "calibre_toc_6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "photo-caption",
    attrs: {
      "id": "calibre_toc_7"
    }
  }, [_vm._v("“I have a publishing contract, and my postcards to the universe book has been published. Thank you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "photo-caption",
    attrs: {
      "id": "calibre_toc_8"
    }
  }, [_vm._v("—Melisa")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("I thought I had a pretty good life: married, living in a small coastal town in a cute little house, and working my dream job. At the time, I photographed dolphins doing therapy with handicapped children. I did this for seven years. But within a thirty-day period, my job ended, my marriage fell apart, and I had to leave my beloved home. It was the most traumatic time of my"), _c('span'), _vm._v("life.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("After years of sadness, loneliness, and confusion (during which I moved in with family), I received a divine message. In that sweet spot between sleep and wakefulness, I heard very clearly the first beckoning to create "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Postcards to the Universe")]), _vm._v(". "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Postcards to the Universe? ")]), _vm._v("The words echoed in my mind. I had no idea what they meant, but intuitively felt they were important. I got out of bed, got online, and bought the domain name, knowing somehow this was something I had been called to"), _c('span'), _vm._v("do.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("I created and founded Postcards to the Universe™ A Global Movement for Manifestation; I invite people from around the world to participate in this movement by using photography, art, personal wishes, and desires, and sending them out to the Universe via a"), _c('span'), _vm._v("postcard.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("My inspiration comes from a desire to host forums where people come together in creative ways for global change. I see and feel a great need for growth, inner reflection, inspiration, and healing by combining art, photography, and"), _c('span'), _vm._v("manifestation.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("I believe we inspire others through collaboration and co-creation. I offer workshops that are not just about photography and art, however—they are about transformation and manifestation. I guide and inspire participants to go within, and they experience huge"), _c('span'), _vm._v("shifts.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Through photography, I use the camera as a device to change old perspectives that no longer serve. Using the camera as a tool to shift our focus, I teach participants to start seeing themselves in a new way—with a new lens, if you"), _c('span'), _vm._v("will.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("In this book, I am featuring the postcards I received either from my workshops or from manifestors who have sent them to me. As you flip through the pages, you will also see each person’s inspirational"), _c('span'), _vm._v("story.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("This is my postcard. I created it a few years ago after attending a writer’s workshop with one of my heroes, author Wayne Dyer. It hangs on my gallery wall, seeping into my consciousness on a regular basis. One of my dreams was to have my book published, and share my vision with the world. This book is witness to one of my greatest desires manifested into reality. This is the Law of Attraction in"), _c('span'), _vm._v("action.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("I hope this book inspires you to go after your dreams; the Universe has your back and will meet you where you want to go. All you have to do is believe it! Of course, you can make a postcard and share your story"), _c('span'), _vm._v("too.")]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_18"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657c4bc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ebook_split_009.vue
// module id = 81
// module chunks = 0